import type { Input as ButtonInput } from "../evo-button/index.marko";
import type { PaddingSize } from "../content-section/index.marko";
import s from "./style.module.css";
export interface Input {
    headline: Marko.AttrTag<Marko.HTML.H2>;
    cta: Marko.AttrTag<ButtonInput>;
    align?: "center" | "left";
    paddingBlock?: (PaddingSize | null)[];
}

<const/{ headline, paddingBlock, cta, align = "center" }=input>
<const/{ content: ctaContent, ...ctaProps }=cta>
<let/isVisible=false>

<content-section class=s.section data-align=align paddingBlock=paddingBlock>
    <div
        class=s.cards
        role="img"
        aria-label="A collage of photos, showing a large crowd with two excited women sharing a high-five; a view of a brightly-lit stage at an eBay company event; a marketing photo of a young woman standing in a room decorated with art and collectibles.">
        <div class=s.card>
            <img
                src="https://ir.ebaystatic.com/cr/v/c01/ebay-design/home-cta-1.jpg"
                alt="">
        </div>
        <div class=s.card>
            <img
                src="https://ir.ebaystatic.com/cr/v/c01/ebay-design/home-cta-3.jpg"
                alt="">
        </div>
        <div class=s.card>
            <img
                src="https://ir.ebaystatic.com/cr/v/c01/ebay-design/home-cta-2.jpg"
                alt="">
        </div>
    </div>

    <h2>
        <${headline.content}/>
    </h2>

    <evo-button ...ctaProps>
        <if=ctaProps.target>
            <@icon>
                <icon-external-link-20/>
            </@icon>
        </if>
        <${ctaContent}/>
    </evo-button>
</content-section>
